import API from "../api";

export const getInfoCoursesType = (course = null) => {
    return API.get(`api/get_edp_nisl_courses`, {
        params: {
            courseKey: course
        }
    });
};
